import { Link } from 'react-router-dom';

import { Button } from '@sandtech-hub-monorepo/ui-kit';

import { ReactComponent as AwardIcon } from '../../assets/Icons/award-icon.svg';
import { AppRoutesPaths, LearningTabSections } from '../../routes/types';

export const AchievementsEmptyState = () => (
  <div className="flex flex-col items-center gap-6 rounded-xl border border-border bg-card px-6 py-20 text-center sm:px-10">
    <div className="flex h-[120px] w-[120px] items-center justify-center rounded-full bg-primary/5 text-primary">
      <AwardIcon className="h-[50px] w-[50px]" />
    </div>
    <div className="flex flex-col items-center gap-2">
      <h3 className="text-2xl font-semibold text-foreground">
        No achievements yet
      </h3>
      <p className="max-w-[480px] text-muted-foreground">
        Complete courses to earn verified certificates, badges, and
        career-boosting credentials.
      </p>
    </div>
    <Button asChild className="h-12 px-8">
      <Link to={`${AppRoutesPaths.Learning}?tab=${LearningTabSections.All}`}>
        Go to programs
      </Link>
    </Button>
  </div>
);
